import { useState } from 'react';

interface UsePreventMultipleClicksReturn {
  isButtonBlocked: boolean;
  blockButton: VoidFunction;
  unblockButton: VoidFunction;
}

/**
 * Custom hook for preventing multiple clicks on action buttons
 * Provides consistent protection across all components and use cases
 */
export const usePreventMultipleClicks = (): UsePreventMultipleClicksReturn => {
  const [isButtonBlocked, setIsButtonBlocked] = useState<boolean>(false);

  const blockButton = () => {
    setIsButtonBlocked(true);
  };

  const unblockButton = () => {
    setIsButtonBlocked(false);
  };

  return {
    isButtonBlocked,
    blockButton,
    unblockButton,
  };
};
